/*eslint-disable */

import InterviewCourses from './interviewCourses';
import MediaDetails from './media';
import PublicQuiz from './publicQuiz';
import QuizBanner from './quizBanner';
import QuizContest from './quizContest';
import Vue from 'vue';
import Vuex from 'vuex';
import assignmentStore from './assignment';
import authVerifiedStore from './authVerifiedStore';
import authentication from './authenticate'
import briefcaseStore from './briefcaseStore';
import interviewContestStore from './interviewContestStore';
import memberUserStore from './memberUserStore';
import notesStore from './notesStore';
import paperpileStore from './paperpileStore';
import paypalPayment from './payment';
import profileStore from './profile';
import publicCourseStore from './publicCourseStore';
import schedulerStore from './schedulerStore';
import todoStore from './todoStore';
import userCourses from './userCourses';
import userNotes from './userNotes';

Vue.use(Vuex);

export default new Vuex.Store({
  strict: true,
  modules: {
    authentication,
    userCourses,
    profileStore,
    publicCourseStore,
    assignmentStore,
    authVerifiedStore,
    paypalPayment,
    MediaDetails,
    userNotes,
    PublicQuiz,
    QuizContest,
    InterviewCourses,
    QuizBanner,
    interviewContestStore,
    paperpileStore,
    memberUserStore,
    briefcaseStore,
    notesStore,
    schedulerStore,
    todoStore
  }
})
